import { put, takeLatest, call } from 'redux-saga/effects';
import { REQUEST_USER_PENDING, REQUEST_USER_SUCCESS, REQUEST_USER_FAIL } from './actions';
import { restClient } from '../common';

export function* setUser() {
  try {
    const payload = yield call(restClient, 'GET_CUSTOM', 'user-balance');
    yield put({ type: REQUEST_USER_SUCCESS, payload: payload.data });
  } catch (error) {
    yield put({ type: REQUEST_USER_FAIL, payload: error.message });
  }
}

export default function* rootSaga() {
  yield takeLatest(REQUEST_USER_PENDING, setUser);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js